<template>
  <loader v-if="loading"
    :label="$t('conflict.searchingTodos')"
  />
  <v-container v-else
  >
    <v-row
      class="white"
      dense
    >
      <v-col
        class="py-0"
      >
        <h3 class="ml-3">{{ $t('conflict.inThisScenario') }}</h3>
        <conflict
          :conflict="conflict"
          :show-details="debugMode"
        />
      </v-col>
    </v-row>
    <v-row
      class="white"
      dense
    >
      <v-col class="px-4 py-2">
        <h3 class="mb-3">{{ $t('option.possible') }}</h3>
        <span class="rai-wigo box">
          <wigo-chip
            v-for="(wigo, index) in conflict.wigos"
            :key="`wigo-${index}`"
            :wigo="wigo"
            link
            class="mr-1"
            :show-details="debugMode"
          />
        </span>
      </v-col>
    </v-row>
    <v-row
      v-if="conflictResolved"
      dense
      class="elevation-2 py-2 my-3 raison-highlight"
    >
      <v-col class="px-5 py-2">
        <p>
          <v-icon color="green">mdi-check</v-icon>{{ $t('conflict.preferencesCombinationTreated') }}
        </p>
        <v-btn
          class="raison-btn"
          @click="clearResolution"
        >
          {{ $t('conflict40.wouldYouLikeToRestart') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-else-if="conflictHasWorkInProgress"
      dense
      justify="start"
      class="elevation-2 py-2 my-3 raison-highlight"
    >
      <v-col class="px-5 py-2">
        <p>
          <v-icon color="orange">mdi-progress-check</v-icon>{{ $t('conflict40.conflictResolutionInProgress') }}
        </p>
        <v-btn
          class="raison-btn"
          @click="continueResolution"
        >
          {{ $t('conflict40.wouldYouLikeToContinue') }}
        </v-btn>
        <v-btn
          class="raison-btn"
          @click="clearResolution"
        >
          {{ $t('conflict40.wouldYouLikeToRestart') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-else
      dense
      class="py-2 mt-4"
    >
      <favorite-options
        @answerSelected="answered($event)"
        :hide-no-i-prefer-making-groups="hasEnougthWigosToMakeGroups"
        :hide-no-i-can-not-decide="hideNoICanNotDecide"
        :hide-no-sense="hideNoSense"
      />
    </v-row>
  </v-container>
</template>
<script>
import Conflict from '@/components/conflictResolution/Conflict'
import FavoriteOptions from '@/components/conflictResolution/FavoriteOptions'
import Loader from '@/components/global/Loader'
import WigoChip from '@/components/global/WigoChip.vue'

import debugModeMixin from '@/mixins/debug-mode-mixin.js'

import conflictService from '@/services/conflicts.js'
import helpService from '@/services/help.js'

export default ({
  name: 'ChooseResolutionMode',
  
  components: {
    Conflict,
    FavoriteOptions,
    Loader,
    WigoChip
  },
  
  mixins: [ debugModeMixin ],
  
  data () {
    return {
      answerSelected: undefined,
      loading: false,
      totalNumberOfConflicts: 0,
      numberOfResolvedConflicts: 0
    }
  },
  
  props: {
    conflict: {
      type: Object,
      required: true
    },
  },
  
  computed: {
    hasEnougthWigosToMakeGroups() {
      return this.conflict.wigos.length < 3
    },
    isConflictOnSameScenario() {
      return conflictService.isConflictOnSameScenario(this.conflict)
    },
    conflictResolved() {
      return conflictService.isConflictResolved(this.conflict)
    },
    conflictHasWorkInProgress() {
      return conflictService.hasConflictWorkInProgress(this.conflict)
    },
    hideNoICanNotDecide() {
      return this.conflict.scenario.level > 1
    },
    hideNoSense() {
      return this.isConflictOnSameScenario || this.conflict.scenario.level > 1
    }
  },

  methods: {
    answered(event) {
      this.answerSelected = event
      console.log('answered', event)
      this.$emit('answered', event)
    },
    clearResolution() {
      this.loading = true
      console.log('clearResolution', this.conflict)
      const projectId = this.$route.params.id
      const conflictId = this.conflict.id

      conflictService.clearResolution(projectId, conflictId)
        .then(() => {
          this.conflict.status = "unresolved"
          helpService.setHelpPage(this.$store, 'conflict_resolution')
          this.$emit('conflictResolutionCleared', this.conflict)
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
    continueResolution() {
      this.loading = true
      console.log('continueResolution', this.conflict)
      const projectId = this.$route.params.id
      const conflictId = this.conflict.id
      conflictService.resume(projectId, conflictId)
        .then(response => {
          this.$emit('nextTodo', response.data)
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
  },

  created () {
    if(!this.conflictResolved && !this.conflictHasWorkInProgress) {
      var helpPage = 'conflict_resolution'
      if(this.hasEnougthWigosToMakeGroups) {
        helpPage += '_hide_no_i_prefer_making_groups'
      }
      if(this.hideNoICanNotDecide) {
        helpPage += '_hide_no_i_can_not_decide'
      }
      // if(this.hideNoSense) {
      //   helpPage += '_no_sense'
      // }
      helpService.setHelpPage(this.$store, helpPage)
    }
    else if(this.conflictResolved) {
      helpService.setHelpPage(this.$store, 'restart')
    }
    else {
      helpService.setHelpPage(this.$store, 'continue_or_restart')
    }
  },
})
</script>
<style>

</style>